// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiIdentity } from '../models/ApiIdentity';
import { HttpFile } from '../http/http';

export class ApiXTdhStats {
    'identity': ApiIdentity;
    'xtdh': number;
    'xtdh_rate': number;
    'multiplier': number;
    'outgoing_rate': number;
    'outgoing_total': number;
    'outgoing_collections_count': number;
    'outgoing_tokens_count': number;
    'incoming_rate': number;
    'incoming_total': number;
    'generated_total': number;
    'generation_rate': number;
    'unused_rate': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "identity",
            "baseName": "identity",
            "type": "ApiIdentity",
            "format": ""
        },
        {
            "name": "xtdh",
            "baseName": "xtdh",
            "type": "number",
            "format": "double"
        },
        {
            "name": "xtdh_rate",
            "baseName": "xtdh_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "multiplier",
            "baseName": "multiplier",
            "type": "number",
            "format": "double"
        },
        {
            "name": "outgoing_rate",
            "baseName": "outgoing_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "outgoing_total",
            "baseName": "outgoing_total",
            "type": "number",
            "format": "double"
        },
        {
            "name": "outgoing_collections_count",
            "baseName": "outgoing_collections_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "outgoing_tokens_count",
            "baseName": "outgoing_tokens_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "incoming_rate",
            "baseName": "incoming_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "incoming_total",
            "baseName": "incoming_total",
            "type": "number",
            "format": "double"
        },
        {
            "name": "generated_total",
            "baseName": "generated_total",
            "type": "number",
            "format": "double"
        },
        {
            "name": "generation_rate",
            "baseName": "generation_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "unused_rate",
            "baseName": "unused_rate",
            "type": "number",
            "format": "double"
        }    ];

    static getAttributeTypeMap() {
        return ApiXTdhStats.attributeTypeMap;
    }

    public constructor() {
    }
}

